<template>
  <a-tooltip>
    <template #title><slot name="title">{{ title }}</slot></template>
    <dol-icon class="dol-icon-button" :class="{disabled: disabled}" :type="icon" @click="buttonClick"/>
  </a-tooltip>
</template>

<script>
export default {
  name: 'dol-icon-button',
  props: {
    icon: { type: String },
    title: { type: String },
    disabled: { type: Boolean, default: false },
  },
  emits: ['buttonClick'],
  data () {
    return {};
  },
  methods: {
    buttonClick(){
      if(this.disabled) return true;
      this.$emit('buttonClick');
    }
  }
}
</script>

<style lang="scss">
@use '../../../assets/scss/constant' as constant;
.dol-icon-button{
  cursor: pointer;
  font-size: 16px;
  color: #666666;

  &:hover{
    color: constant.$primaryColor;
  }

  &.disabled{
    cursor: not-allowed;
    color: #cccccc;
    &:hover{
      color: #cccccc;
    }
  }
}
</style>
